import { Box, Grid, ListItem, makeStyles } from '@material-ui/core';
import { memo } from 'react';

import { SETVIImage, SHighlightText } from '@setvi/shared/components';
import { useResourceOpener } from '@setvi/shared/providers';
import { Resource } from '@setvi/shared/interfaces';

import ResourceBreadcrumbs from 'Components/Shared/ResourceBreadcrumbs';
import DropdownMenu from 'Components/Shared/Resources/DropdownMenu';
import { DropdownItemsType } from 'Components/Shared/Resources/DropdownMenu/hooks';

interface ISearchResult {
  resource: Resource;
  searchQuery: string;
  handleSearchClose: () => void;
}

const useSearchStyles = makeStyles(() => ({
  image: {
    width: '80%',
    borderRadius: '5px',
    display: 'block'
  },
  title: {
    fontsize: 14
  },
  listItem: {
    paddingLeft: 24
  },
  content: {
    maxWidth: '100%',
    lineHeight: 0
  },
  pageInfo: {
    fontSize: 13,
    color: '#92929D'
  }
}));

// `printOrder` only renders where the print-order feature is active (the
// shoppingCart flag, on Home and Resources), so it costs nothing elsewhere.
const dropdownItems: DropdownItemsType = [
  'email',
  'download',
  'printOrder',
  'getLink',
  'moreInfo',
  'goToCategory'
];

const SearchResult = ({
  resource,
  searchQuery,
  handleSearchClose
}: ISearchResult) => {
  const style = useSearchStyles();
  const { openResource } = useResourceOpener();

  return (
    <>
      <Grid container spacing={0}>
        <ListItem
          button
          className={style.listItem}
          onClick={() =>
            openResource({
              name: resource.Name,
              resourceTypeId: resource.ResourceTypeID,
              resourceId: resource.ResourceID,
              resource
            })
          }>
          <Grid item xs={2}>
            <SETVIImage
              src={resource.ThumbURL}
              className={style.image}
              alt={resource.Name}
            />
          </Grid>
          <Grid item xs={9}>
            <Box className={style.content}>
              <SHighlightText value={resource.Name} searchQuery={searchQuery} />
            </Box>
            <Box>
              <ResourceBreadcrumbs
                additionalOnClick={handleSearchClose}
                breadcrumbs={resource.Breadcrumbs}
              />
            </Box>
            {resource.PageNumber && (
              <Box className={style.pageInfo}>
                Found on page: {resource.PageNumber}
              </Box>
            )}
          </Grid>
          <Grid item xs={1}>
            <Box onClick={e => e.stopPropagation()}>
              <DropdownMenu
                item={resource}
                dropdownItems={dropdownItems}
                handleCloseDropdown={handleSearchClose}
              />
            </Box>
          </Grid>
        </ListItem>
      </Grid>
    </>
  );
};

export default memo(SearchResult);
